import { HttpClient, RequestConfig } from "@planzone/services";

function createDocumentUrlProvider(httpClient: HttpClient): HttpClient {
  return {
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return httpClient.sendHttpRequest({
        baseUrl: "/docs",
        ...config,
      });
    },
  };
}

export { createDocumentUrlProvider };
